import { FC } from "react";

import { Icon, IconProps } from "@chakra-ui/icons";

const CustomIcon: FC<Omit<IconProps, "css">> = ({ children, ...props }) => (
  <Icon width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
    <path
      d="M11.8072 4.45732H10.1001C10.2898 4.06217 10.3846 3.6196 10.3846 3.14542C10.3846 1.40674 8.97787 0 7.2392 0C5.50053 0 4.09378 1.40674 4.09378 3.14542C4.09378 3.6196 4.20443 4.06217 4.37829 4.45732H2.67123L0 15H5.24763H9.23077H14.4784L11.8072 4.45732ZM7.2392 1.01159C8.40885 1.01159 9.37302 1.95996 9.37302 3.12961C9.37302 3.6196 9.19916 4.07798 8.91465 4.44152H5.56375C5.27924 4.07798 5.10537 3.6196 5.10537 3.12961C5.10537 1.95996 6.06955 1.01159 7.2392 1.01159ZM5.24763 14.0832H1.16965L3.38251 5.37408H5.01054H5.24763H9.23077H9.46786H11.0959L13.3087 14.0832H9.23077H5.24763Z"
      fill="black"
    />
  </Icon>
);

export default CustomIcon;
